import { InpoolLanguage } from '../../models/InpoolLanguage';
import {
  TemplateTranslation,
  TranslationKeyTranslation,
} from '../../models/translation';
import { translationsDe } from './locales/translations-de';
import { translationsEn } from './locales/translations-en';
import { translationsFr } from './locales/translations-fr';
import { templatesDe } from './templates/templates-de';
import { templatesEn } from './templates/templates-en';
import { templatesFr } from './templates/templates-fr';

export function loadTranslation(
  locale: InpoolLanguage = 'de',
): TranslationKeyTranslation {
  switch (locale) {
    case 'de':
      return translationsDe;
    case 'en':
      return translationsEn;
    case 'fr':
      return translationsFr;
  }
}

export function loadTranslations(): TranslationKeyTranslation[] {
  return [translationsDe, translationsEn, translationsFr];
}

export function loadTemplateTranslation(
  locale: InpoolLanguage = 'de',
): TemplateTranslation {
  switch (locale) {
    case 'de':
      return templatesDe;
    case 'en':
      return templatesEn;
    case 'fr':
      return templatesFr;
  }
}
